import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { User } from '../../_objects/user';

import { ApiService } from '../base/api-base.service';
import { MeUserContractService } from '../interfaces/me-user-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { MeUserOfflineService } from '../offline/me-user-offline.service';
import { MeUserOnlineService } from '../online/me-user-online.service';

@Injectable()
export class MeUserService extends ApiService<MeUserContractService> implements MeUserContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: MeUserOfflineService,
    protected onlineService: MeUserOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  // ME01 GET /api/v1/me
  getMe(): Observable<User> {
    return this.service.getMe();
  }
  // ME02 PUT /api/v1/me/terms/agree
  putUserAgreeTerms(): Observable<User> {
    return this.service.putUserAgreeTerms();
  }

  getReportTemplateBuilderEndpoint(params: string[], query: string) {
    return this.onlineService.getReportTemplateBuilderEndpoint(params, query);
  }

}
